module.exports = __webpack_public_path__ + "assets/8f328697c8bdb76bb07a9a260558b24c.mp3";